import { Modal } from "@mantine/core";
import { FC, useEffect, useState } from "react";
import ic_image_default from "../../assets/icons/ic_image_default.svg";
import ic_product_default from "../../assets/icons/ic_product_default.svg";
import ic_user_default from "../../assets/icons/ic_user_default.svg";
import CookieUtils from "../../utils/cookie-utils";

interface ImageProps {
  url?: string;
  className?: string;
  onClick?: () => void;
  fallBackUrl?: string;
  style?: React.CSSProperties;
  isLocal?: boolean;
  isUser?: boolean;
  isReview?: boolean;
  isProduct?: boolean;
}

const ImageCustom: FC<ImageProps> = ({
  url,
  className,
  onClick,
  fallBackUrl,
  style,
  isLocal = true,
  isUser = true,
  isReview = false,
  isProduct = false,
}: ImageProps) => {
  const [imageSrc, setImageSrc] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const imageDefault = isUser ? ic_user_default : ic_image_default;
  const imageDefaultProduct = isProduct ? ic_product_default : imageDefault;

  useEffect(() => {
    
    const resolvedUrl = url ?? imageDefaultProduct;
    setImageSrc(isLocal ? resolvedUrl : `${CookieUtils.getDomain().resource_domain}${resolvedUrl}`);
  }, [url, isLocal, imageDefault, imageDefaultProduct]);

  const handleError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    event.currentTarget.onerror = null; 
    event.currentTarget.src = fallBackUrl ?? imageDefaultProduct;
  };

  const handleClick = () => {
    if (isReview) {
      setIsModalOpen(true);
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <>
      {onClick || isReview ? (
        <button className="w-full h-full p-0 border-none" onClick={handleClick} style={style}>
          <img className={className} src={imageSrc} onError={handleError} alt="" />
        </button>
      ) : (
        <img className={className} src={imageSrc} onError={handleError} style={style} alt="" />
      )}

      {isReview && (
        <Modal
          opened={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          size="80%"
          withCloseButton={false}
          transitionDuration={350}
          exitTransitionDuration={350}
        >
          <div style={{ height: "calc(100vh - 48px - 48px)" }} className="p-2">
            <img className="object-contain w-full h-full" src={imageSrc} onError={handleError} alt="" />
          </div>
        </Modal>
      )}
    </>
  );
};

export default ImageCustom;
